import strings from 'owa-strings/owa-mail-strings';
import { isViewStateDirty } from './viewStateUtils';
var BEFORE_UNLOAD_EVENT = 'beforeunload';
var activeViewStates = [];
var beforeUnloadHandlerAdded = false;
function onBeforeUnload(ev) {
    for (var _i = 0, activeViewStates_1 = activeViewStates; _i < activeViewStates_1.length; _i++) {
        var viewState = activeViewStates_1[_i];
        if (isViewStateDirty(viewState)) {
            ev.returnValue = strings.beforeUnloadConfirmationText;
            break;
        }
    }
}
export function addViewStateToBeforeUnloadHandler(viewState) {
    if (activeViewStates.indexOf(viewState) < 0) {
        activeViewStates.push(viewState);
        if (!beforeUnloadHandlerAdded) {
            window.addEventListener(BEFORE_UNLOAD_EVENT, onBeforeUnload);
            beforeUnloadHandlerAdded = true;
        }
    }
}
export function removeViewStateFromBeforeUnloadHandler(viewState) {
    var index = activeViewStates.indexOf(viewState);
    if (index >= 0) {
        activeViewStates.splice(index, 1);
        if (activeViewStates.length == 0 && beforeUnloadHandlerAdded) {
            window.removeEventListener(BEFORE_UNLOAD_EVENT, onBeforeUnload);
            beforeUnloadHandlerAdded = false;
        }
    }
}
//# sourceMappingURL=beforeUnloadHandler.js.map